export { default } from './Splitter'
